export default __webpack_public_path__ + "static/media/PosterMB-3.c6811f2f.JPG";